up.compiler('[data-focus-trap]', (element) => {
  const focusTrapStart = up.element.affix(
    element,
    'afterbegin',
    'div.hide-focus-outline[tabindex=0]',
  ) as HTMLElement
  const focusTrapEnd = up.element.affix(
    element,
    'beforeend',
    'div.hide-focus-outline[tabindex=0]',
  ) as HTMLElement

  const FOCUSABLE_SELECTORS = [
    'a[href]:not([disabled])',
    'button:not([disabled])',
    'textarea:not([disabled])',
    'input:not([type="hidden"]):not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(', ')

  const KEYCODE_TAB = 9

  const focusableElements = [...element.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTORS)]

  function nextFocusableElement(offset = 1) {
    const currentIndex = document.activeElement
      ? focusableElements.indexOf(document.activeElement as HTMLElement)
      : 0
    const nextIndex = (currentIndex + offset) % focusableElements.length

    return focusableElements[nextIndex]
  }

  function tryFocus(focusableElement: HTMLElement) {
    focusableElement.focus()
    return focusableElement === document.activeElement
  }

  function focusNextElement(reverse = false, offset = 1) {
    if (offset >= focusableElements.length) {
      return
    }
    const nextElementFocused = tryFocus(nextFocusableElement(offset))
    if (!nextElementFocused) {
      offset = reverse ? offset - 1 : offset + 1
      focusNextElement(reverse, offset)
    }
  }

  element.addEventListener('keyup', function (event: KeyboardEvent) {
    if (event.key !== 'Tab' && event.keyCode !== KEYCODE_TAB) {
      return
    }

    if (event.shiftKey) {
      /* shift + tab */ if (document.activeElement === focusTrapStart) {
        focusTrapEnd.focus()
        focusNextElement(true, -1)
        event.preventDefault()
      }
    } /* tab */ else {
      if (document.activeElement === focusTrapEnd) {
        focusTrapStart.focus()
        focusNextElement()
        event.preventDefault()
      }
    }
  })

  up.on(element, 'app.focusTrap.focus', function () {
    focusTrapStart.focus()
    focusNextElement()
  })
})
